//@flow

import type { Error } from 'error';
import { KnownErrorsHelper } from './known-errors-helper';

const HTTP_BAD_REQUEST = 400;
const HTTP_NOT_FOUND = 404;
const HTTP_INTERNAL_SERVER_ERROR = 500;

//Хелпер для проверки http ошибок
export class HttpErrorsHelper {

	static isBadRequest = (e: Error) => {
		return KnownErrorsHelper.isHttpError(e)
			&& e.response
			&& e.response.status === HTTP_BAD_REQUEST;
	};

	static isNotFound = (e: Error) => {
		return KnownErrorsHelper.isHttpError(e)
			&& e.response
			&& e.response.status === HTTP_NOT_FOUND;
	}

	static isInternalServerError = (e: Error) => {
		return KnownErrorsHelper.isHttpError(e)
			&& e.response
			&& e.response.status === HTTP_INTERNAL_SERVER_ERROR;
	};
}